(function () {
  'use strict';
  var PRODUCT_ID = '15113446752640';
  function formatTitle(value, location) {
    value = String(value || '').trim();
    location = String(location || '').trim();
    return [value ? 'Title: ' + value : '', location ? 'Mark a location: ' + location : ''].filter(Boolean).join('\n');
  }
  function readTitle(value) {
    return String(value || '').replace(/(?:^|\n)Mark a location:[\s\S]*$/i, '').replace(/^Title(?: or names)?:\s*/i, '').trim();
  }
  function readLocation(value) {
    var match = String(value || '').match(/(?:^|\n)Mark a location:\s*([\s\S]*)$/i);
    return match ? match[1].trim() : '';
  }
  function readLegend(value) {
    return String(value || '').replace(/\r/g, '').split(/\n|[ \t]+(?=\d+\)[ \t]+)/).map(function (line) {
      return line.replace(/^\s*\d+[.)]\s*/, '').trim();
    }).filter(Boolean);
  }
  function formatLegend(lines) {
    return lines.map(function (value) { return String(value || '').trim(); }).filter(Boolean).map(function (value, index) {
      return (index + 1) + ') ' + value;
    }).join('\n');
  }
  function mount(section) {
    if (section.querySelector('[data-pdp-travel-personalisation]')) return true;
    var io = section.querySelector('#infiniteoptions-container');
    if (!io) return false;
    var titleSource = io.querySelector('textarea[name="properties[Free personalisation]"], textarea[name-disabled="properties[Free personalisation]"]');
    var legendSource = io.querySelector('textarea[name="properties[Custom legend]"], textarea[name-disabled="properties[Custom legend]"]');
    var titleCard = titleSource && titleSource.closest('.io-card, .not_same_line');
    var legendCard = legendSource && legendSource.closest('.io-card, .not_same_line');
    if (!titleCard || !legendCard) return false;
    var widget = document.createElement('section');
    widget.className = 'pdp-travel-personalisation';
    widget.setAttribute('data-pdp-travel-personalisation', '');
    widget.innerHTML =
      '<p class="pdp-travel-personalisation__subtitle">Make it yours with a personalised title and travel key, included in the price.</p>' +
      '<div class="pdp-travel-personalisation__card">' +
        '<div class="pdp-travel-personalisation__group"><label class="pdp-travel-personalisation__label" data-travel-title-label>Title for your map <span class="pdp-travel-personalisation__optional">(optional)</span></label>' +
        '<div data-travel-title></div></div>' +
        '<fieldset><legend>Travel key <span class="pdp-travel-personalisation__info" data-travel-key-info></span> <span class="pdp-travel-personalisation__optional">(optional)</span></legend>' +
          '<p class="pdp-travel-personalisation__help">Labels explaining what your pins represent.</p>' +
          '<div class="pdp-travel-personalisation__lines" data-travel-lines></div>' +
          '<button type="button" class="pdp-travel-personalisation__link pdp-travel-personalisation__add" data-travel-add>Add another label</button>' +
        '</fieldset>' +
        '<div class="pdp-travel-personalisation__group">' +
          '<div class="pdp-travel-personalisation__label">Mark a special place</div>' +
          '<p class="pdp-travel-personalisation__help">We can print a marker for your home, a favourite destination or another meaningful place.</p>' +
          '<button type="button" class="pdp-travel-personalisation__link" data-travel-location-toggle aria-expanded="false">Add a location</button>' +
          '<div class="pdp-travel-personalisation__location" data-travel-location hidden></div></div>' +
        '<p class="pdp-travel-personalisation__proof">We’ll arrange the design to suit your map.<br>You approve the proof before printing.</p>' +
        '<p class="pdp-travel-personalisation__contact">Have something else in mind? <button type="button" class="pdp-travel-personalisation__link" data-travel-contact>Contact the workshop</button></p>' +
      '</div>';
    var tooltipTemplate = document.querySelector('[data-pdp-travel-key-tooltip-template]');
    if (tooltipTemplate) {
      var info = widget.querySelector('[data-travel-key-info]');
      info.appendChild(tooltipTemplate.content.cloneNode(true));
      var tooltipTrigger = info.querySelector('tool-tip-trigger');
      tooltipTrigger.setAttribute('role', 'button');
      tooltipTrigger.setAttribute('tabindex', '0');
      tooltipTrigger.setAttribute('aria-label', 'See a travel key example');
      tooltipTrigger.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); tooltipTrigger.click(); }
      });
    }
    var linesHost = widget.querySelector('[data-travel-lines]');
    var titleHost = widget.querySelector('[data-travel-title]');
    var rows = [], writing = false, sequence = 0;
    var lastTitle = titleSource.value, lastLegend = legendSource.value;
    var idPrefix = 'pdp-travel-' + String(section.id || PRODUCT_ID).replace(/[^\w-]/g, '-');
    function writeSource(source, value, commit) {
      var changed = source.value !== value;
      if (!changed && !commit) return;
      writing = true;
      source.value = value;
      if (source === titleSource) lastTitle = value;
      else lastLegend = value;
      if (changed) source.dispatchEvent(new Event('input', {bubbles: true}));
      if (commit) source.dispatchEvent(new Event('change', {bubbles: true}));
      writing = false;
    }
    function writeLegend(commit) {
      writeSource(legendSource, formatLegend(rows.map(function (row) { return row.input.value; })), commit);
    }
    function makeRow(value, placeholder, name, onWrite, onRemove) {
      var element = document.createElement('div');
      element.className = 'pdp-travel-personalisation__line';
      var input = document.createElement('input');
      input.type = 'text';
      input.setAttribute('data-travel-input', '');
      input.id = idPrefix + '-line-' + (++sequence);
      input.placeholder = placeholder;
      input.value = value;
      input.setAttribute('aria-label', name);
      element.appendChild(input);
      input.addEventListener('input', function () { onWrite(false); });
      input.addEventListener('change', function () { onWrite(true); });
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') { event.preventDefault(); onWrite(true); }
      });
      var remove;
      if (onRemove) {
        remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'pdp-travel-personalisation__link';
        remove.textContent = 'Remove';
        remove.setAttribute('data-travel-remove', '');
        remove.setAttribute('aria-label', 'Remove ' + name.toLowerCase());
        remove.addEventListener('click', onRemove);
        element.appendChild(remove);
      }
      return {element: element, input: input, refresh: function (next) {
        input.value = next;
      }};
    }
    var titleRow = makeRow(readTitle(lastTitle), 'The Williams Family’s Adventures', 'Title for your map', function (commit) {
      writePersonalisation(commit);
    });
    titleRow.input.setAttribute('data-travel-title-input', '');
    titleHost.appendChild(titleRow.element);
    widget.querySelector('[data-travel-title-label]').htmlFor = titleRow.input.id;
    var locationRow = makeRow(readLocation(lastTitle), 'A place name, address or coordinates', 'Mark a location', writePersonalisation);
    locationRow.input.setAttribute('data-travel-location-input', '');
    widget.querySelector('[data-travel-location]').appendChild(locationRow.element);
    var locationHost = widget.querySelector('[data-travel-location]');
    var locationToggle = widget.querySelector('[data-travel-location-toggle]');
    locationHost.id = idPrefix + '-location';
    locationToggle.setAttribute('aria-controls', locationHost.id);
    function showLocation(expanded) {
      locationHost.hidden = !expanded;
      locationToggle.setAttribute('aria-expanded', String(expanded));
      locationToggle.textContent = expanded ? 'Remove location marker' : 'Add a location';
    }
    showLocation(Boolean(locationRow.input.value.trim()));
    locationToggle.addEventListener('click', function () {
      var expanded = locationHost.hidden;
      if (!expanded) { locationRow.refresh(''); writePersonalisation(true); }
      showLocation(expanded);
      if (expanded) locationRow.input.focus({preventScroll: true});
    });
    function writePersonalisation(commit) {
      writeSource(titleSource, formatTitle(titleRow.input.value, locationRow.input.value), commit);
    }
    function numberRows() {
      rows.forEach(function (row, index) {
        row.input.setAttribute('aria-label', 'Travel key line ' + (index + 1));
        var remove = row.element.querySelector('[data-travel-remove]');
        if (remove) remove.setAttribute('aria-label', 'Remove travel key line ' + (index + 1));
      });
    }
    function addLine(value) {
      var index = rows.length;
      var placeholder = index === 0 ? "Places we’d like to go" : "Another label";
      var row = makeRow(value, placeholder, 'Travel key line ' + (index + 1), writeLegend, index > 0 ? function () {
        rows.splice(rows.indexOf(row), 1);
        row.element.remove();
        numberRows();
        writeLegend(true);
        widget.querySelector('[data-travel-add]').focus({preventScroll: true});
      } : null);
      rows.push(row);
      linesHost.appendChild(row.element);
      return row;
    }
    function fillLegend(value) {
      linesHost.replaceChildren();
      rows = [];
      var values = readLegend(value);
      if (!values.length) values.push('');
      values.forEach(addLine);
    }
    function readSources() {
      if (writing) return;
      if (titleSource.value !== lastTitle) {
        lastTitle = titleSource.value;
        titleRow.refresh(readTitle(lastTitle));
        locationRow.refresh(readLocation(lastTitle));
        showLocation(Boolean(locationRow.input.value.trim()));
      }
      if (legendSource.value !== lastLegend) {
        lastLegend = legendSource.value;
        fillLegend(lastLegend);
      }
    }
    fillLegend(lastLegend);
    widget.querySelector('[data-travel-add]').addEventListener('click', function () { addLine('').input.focus(); });
    [titleSource, legendSource].forEach(function (source) {
      source.addEventListener('input', readSources);
      source.addEventListener('change', readSources);
    });
    window.addEventListener('um:pdp-configuration-restored', readSources);
    widget.querySelector('[data-travel-contact]').addEventListener('click', function (event) {
      var trigger = document.getElementById('pdp-personalisation-contact-' + PRODUCT_ID + '-trigger');
      var panel = trigger && trigger.closest('[data-contact-advice-panel]');
      if (!panel) return;
      event.preventDefault();
      trigger.textContent = 'Contact the workshop';
      panel.setAttribute('data-contact-workshop-trigger-online', 'Contact the workshop');
      panel.setAttribute('data-contact-workshop-trigger-offline', 'Contact the workshop');
      event.currentTarget.replaceWith(panel);
      trigger.click();
    });
    var heading = section.querySelector('[data-pdp-finish-first-personalisation-title]');
    if (heading) heading.insertAdjacentElement('afterend', widget);
    else legendCard.parentNode.insertBefore(widget, legendCard);
    // Keep the original app controls active and in place for validation,
    // basket properties, the PDP summary and shared-configuration restoration.
    titleCard.setAttribute('data-pdp-travel-personalisation-source', '');
    legendCard.setAttribute('data-pdp-travel-personalisation-source', '');
    return true;
  }
  function init() {
    document.querySelectorAll('.product-section[data-product-id="' + PRODUCT_ID + '"]').forEach(function (section) {
      if (section.__pdpTravelPersonalisation) return;
      section.__pdpTravelPersonalisation = true;
      if (mount(section)) return;
      var observer = new MutationObserver(function () {
        if (mount(section)) observer.disconnect();
      });
      observer.observe(section, {childList: true, subtree: true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
